var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout", { attrs: { "no-sidebar": true } }, [
    _c("div", { staticClass: "page-header" }, [
      _c("h1", [_c("small", [_vm._v("Airports")])])
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4 margin-bottom-3x" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                ref: "search",
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Search for..." },
                domProps: { value: _vm.searchKey },
                on: {
                  keyup: function($event) {
                    if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
                      return null
                    }
                    return _vm.search(_vm.$refs.search.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "input-group-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.search(_vm.$refs.search.value)
                      }
                    }
                  },
                  [_vm._v("Go!")]
                )
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-3x fa-fw" })
        ])
      : _c(
          "div",
          [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("ID")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Airport Name")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Country")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("IATA Code")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.airportsList, function(item) {
                      return _c("tr", { key: item.id }, [
                        _c("td", [_vm._v(_vm._s(item.id))]),
                        _vm._v(" "),
                        _c("td", [
                          _c("strong", { staticClass: "f16" }, [
                            _vm._v(_vm._s(item.airport_name))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.country))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(item.iata_code))])
                      ])
                    }),
                    _vm._v(" "),
                    !_vm.airportsList.length
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "4" }
                            },
                            [_vm._v("No airports found")]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _c("pagination", {
              attrs: { "pages-number": _vm.airports.last_page || 1 },
              on: {
                pageChanged: function(page) {
                  return _vm.loadPage(page)
                }
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52b1bcc4", { render: render, staticRenderFns: staticRenderFns })
  }
}